import { render } from "./JobRegistration.vue?vue&type=template&id=779a9b46&scoped=true"
import script from "./JobRegistration.vue?vue&type=script&lang=js"
export * from "./JobRegistration.vue?vue&type=script&lang=js"

import "./JobRegistration.vue?vue&type=style&index=0&id=779a9b46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-779a9b46"]])

export default __exports__